import actions from "./actions";

const initState = {
  chatrActivationReportResult: [],
  loading: false,
  error: null,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_CHATR_ACTIVATION_REPORT_REQUEST_LIST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.GET_CHATR_ACTIVATION_REPORT_REQUEST_LIST_SUCCESSFUL:
      return {
        ...state,
        loading: false,
        error: null,
        chatrActivationReportResult: action.payload.data,
      };
    case actions.GET_CHATR_ACTIVATION_REPORT_REQUEST_LIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
}
